import React, { useContext, Dispatch, SetStateAction } from "react";
import { useMutation } from "react-query";
import { Trans, useTranslation } from "react-i18next";
import FormContext from "../../state/FormContext";

// Assuming that Styles is a CSS module or styled-components used for styling
import Styles from "./LoginOrRegister.module.scss";
import { PostRequest } from "@/api/RequestTemplates";
import Button from "@/shared/components/Button/Button";
import classNames from "classnames";
import { useTheme } from "@/shared/styles/useTheme";
import { Spinner } from "@/shared/components";
import { handleAuthSuccess } from "@/auth/utils/authUtils";

type MagicLinkProps = {
  toggleMessage: Dispatch<SetStateAction<boolean>>;
  messageCase: boolean;
  linkExpiredCase?: boolean;
  mode?: "Navbar" | "SOF" | "CSF";
};

const MagicLink = ({ toggleMessage, messageCase, linkExpiredCase, mode }: MagicLinkProps) => {
  const { t } = useTranslation();
  const { state } = useContext(FormContext);
  const { primaryColorBorder, primaryColor } = useTheme();

  const requestLoginLink = useMutation({
    mutationFn: () =>
      PostRequest(`${process.env.API_SERVER_URL}/users/request-login-link`, { email: state.values?.email }),
    onSuccess: () => {
      toggleMessage(true);
      const customEvent = new CustomEvent("AuthEvent", {
        // TODO: add userId when its returned from the backend
        detail: { userId: "", platform: "MagicLink" },
      });
      handleAuthSuccess();
      window.dispatchEvent(customEvent);
    },
  });

  const handleMagicLinkClick = () => {
    requestLoginLink.mutate();
  };

  return (
    <div className={classNames(Styles.MagicLinkContainer, messageCase && Styles.MsgContainer)}>
      {!messageCase ? (
        <>
          <Button fullWidth secondary disabled={requestLoginLink.isLoading} onClick={handleMagicLinkClick}>
            <>
              <span>
                {" "}
                {linkExpiredCase ? t("magicLink.requestLinkButtonExpired") : t("magicLink.requestLinkButton")}
              </span>
              {requestLoginLink.isLoading && (
                <div className={Styles.loader}>
                  <Spinner />
                </div>
              )}
            </>
          </Button>
        </>
      ) : (
        <>
          <div className={classNames(Styles.form, primaryColorBorder, Styles.magicForm)}>
            <form>
              <h1 className={Styles.loginTitle}>{t("magicLink.successTitle")}</h1>
              <div className={Styles.fieldWrapper}>
                <Trans
                  i18nKey={"magicLink.successMessage"}
                  values={{
                    email: state.values.email,
                  }}
                >
                  <strong>{state.values.email}</strong>
                </Trans>
              </div>
            </form>
          </div>
        </>
      )}
      {messageCase && (
        <footer className={Styles.footer}>
          <strong>{t("magicLink.howItWorksTitle")}</strong>
          <p>{t("magicLink.howItWorksDescription")}</p>
        </footer>
      )}

      {messageCase && mode === "SOF" && (
        <>
          <div className={Styles.divider} />

          <footer>
            <p>
              <Trans i18nKey={"magicLink.csfFooterMagicLink"}>
                <b />
                <a href="mailto:service@remind.me" className={primaryColor} />
              </Trans>
            </p>
          </footer>
        </>
      )}
    </div>
  );
};

export default MagicLink;
